import React from 'react';
import ConfiguracionBase from '../../components/configuracion/ConfiguracionBase';

const HELP = {
  prereqs: [
    'Tener cargada al menos una sucursal antes de agregar obras: cada obra pertenece obligatoriamente a una.',
    'Tener cargados los centros de costo antes de agregar obras.',
    'Las ubicaciones de la obra se vinculan desde Configuración → Ubicaciones.',
    'Cada obra puede tener múltiples ubicaciones.',
  ],
  tips: [
    'Se puede asignar una obra a cada equipo.',
    'Los usuarios solo pueden administrar equipos de la obra a la que están asignados.',
    'El almacén es propio de cada obra.',
  ],
  nextSteps: [
    'Asignar a los usuarios las obras a la que pertenecen.',
    'En planillas de mantenimiento y reparaciones, los equipos indicarán la obra a la que pertenecen.',
    'Cada movimiento logístico de los equipos entre obras modifica la obra asignada al mismo, y también su sucursal si la nueva obra pertenece a una distinta.',
  ],
};

const ConfiguracionObras = (props) => {
  return (
    <ConfiguracionBase
      apiEndpoint="obras"
      titulo="Obras"
      descripcion="Gestión de obras operativas"
      icon="fas fa-road"
      compact
      help={HELP}
      {...props}
    />
  );
};

export default ConfiguracionObras;
